
// example input
// [{
//     "no": 1,
//     "name": "Jhiro Faran",
//     "q1y2": 0,
//     "q2y2": 0,
//     "q3y2": 0,
//     "q4y2": 0,
//     "q1y1": 0,
//     "q2y1": 0,
//     "q3y1": 2,
//     "q4y1": 0,
//     "q1y": 0,
//     "q2y": 1,
//     "q3y": 0,
//     "q4y": 0
//   }]

function transformChartData(input) {
  if (!input?.length) {
    return { data: [], dataKey: [] };
  }

  // Ambil semua nama quarter, kecuali 'name' dan 'no'
  const quarterKeys = Object.keys(input[0]).filter(
    key => key !== "namaCabang" && key !== "no"
  );

  if (!quarterKeys.length) {
    return { data: [], dataKey: [] };
  }

  // Ambil semua nama (kecuali TOTAL)
  const employeeNames = input
    .map(entry => entry.namaCabang)
    .filter(name => name !== "TOTAL");

  // Susun data bar chart per quarter
  const chartData = quarterKeys.map(quarter => {
    const includesRate = quarter.includes('Rate')
    const row = { division: includesRate ? quarter : quarter?.toUpperCase() };

    input.forEach(entry => {
      if (entry.namaCabang !== "TOTAL") {
        row[entry.namaCabang] = entry[quarter];
      }
    });
    return row;
  });

  // Buat dataKey dengan warna
  const colorPalette = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50", "#a0522d"];
  const dataKey = employeeNames.map((name, index) => ({
    key: name,
    color: colorPalette[index % colorPalette.length]
  }));

  return {
    data: chartData,
    dataKey
  };
}

export const service = {
  transformChartData
};
